import { useEffect, useRef } from "react";

/**
 * Run a callback once when the referenced element first intersects the viewport.
 * Works reliably regardless of whether the page is using a custom scroll container
 * (e.g. snap-root) or the window — both fire IntersectionObserver entries.
 */
export default function useReveal(ref, callback, options = {}) {
  const fired = useRef(false);
  useEffect(() => {
    if (!ref.current || fired.current) return;
    const el = ref.current;
    const obs = new IntersectionObserver(
      (entries) => {
        for (const e of entries) {
          if (e.isIntersecting && !fired.current) {
            fired.current = true;
            callback(e);
            obs.disconnect();
            return;
          }
        }
      },
      { threshold: 0.18, ...options }
    );
    obs.observe(el);
    return () => obs.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
